var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"block",staticClass:"phonebox",style:(_vm.style)},[_c('img',{style:(_vm.style),attrs:{"src":require("../img/phone.svg")}}),_c('div',{ref:"scroller",staticClass:"absolute-item"},[_c('div',{staticClass:"yo-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }